"use client";

import { useEffect, useRef } from "react";

export default function DynamicPage({ htmlContent }: { htmlContent: string }) {
  const containerRef = useRef<HTMLDivElement>(null);

  const cleanHtml = (html: string) => {
    return html.replace(
      /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
      ""
    );
  };

  const sanitizedHtml = cleanHtml(htmlContent);

  useEffect(() => {
    if (!containerRef.current) return;

    const doc = new DOMParser().parseFromString(htmlContent, "text/html");

    const scripts: HTMLScriptElement[] = [];
    
    doc.querySelectorAll("script").forEach((script) => {
      if (script.src) {
        scripts.push(script);
      } else if (script.textContent) {
        scripts.push(script);
      }
      script.remove();
    });

    scripts.forEach((script) => {
      const newScript = document.createElement("script");

      if (script.src) {
        newScript.src = script.src;
        newScript.async = true;
      } else if (script.textContent) {
        newScript.textContent = script.textContent;
      }

      document.body.appendChild(newScript);
    });
  }, []);

  return (
    <div
      ref={containerRef}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}
